import { AnimatedTreeChevron, IconSize } from '@ardoq/icons';
import { NavigatorItemExpander } from './Atoms';
import { colors } from '@ardoq/design-tokens';

export const EXPANDER_TOGGLE_ATTRIBUTE = 'data-expander-toggle';

/** The expand/collapse toggle, not the empty spacer a leaf renders in its place. */
export const EXPANDER_TOGGLE_SELECTOR = `[${EXPANDER_TOGGLE_ATTRIBUTE}]`;

type NodeExpanderProps = {
  readonly hasVisibleContent: boolean;
  readonly isExpanded: boolean;
  readonly name: string;
};

export const NodeExpander = ({
  hasVisibleContent,
  isExpanded,
  name,
}: NodeExpanderProps) => {
  const ariaLabel = isExpanded ? `Collapse ${name}` : `Expand ${name}`;
  return hasVisibleContent ? (
    <NavigatorItemExpander
      aria-label={ariaLabel}
      role="button"
      {...{ [EXPANDER_TOGGLE_ATTRIBUTE]: true }}
    >
      {hasVisibleContent && (
        <AnimatedTreeChevron
          iconSize={IconSize.SMALL}
          $isUp={isExpanded}
          color={colors.grey900}
        />
      )}
    </NavigatorItemExpander>
  ) : (
    <NavigatorItemExpander />
  );
};
